import { OrgService } from '@service/org';
import { type Media,useMediaUpsert } from '@store/entities/media';
import { useCallback } from 'react';

import type { Organization, UpdateOrganizationInput } from '../types';
import { useMeOrgResponse } from './useMeOrgResponse';

export const useMeOrgCommand = () => {
  const { doUpdateOrg, updateOrgLoading } = OrgService.updateOrg();

  const { doGetOrganization, loading: getOrgLoading } = OrgService.getOrganization();
  const { setMeOrgFromResponse } = useMeOrgResponse();
  const { upsert } = useMediaUpsert();

  const updateOrganization = useCallback(
    async (orgId: string, updateInput: UpdateOrganizationInput) => {
      const res = await doUpdateOrg(orgId, updateInput);

      if (res.organization) {
        setMeOrgFromResponse(res.organization as Organization);
      }

      return res;
    },
    [doUpdateOrg, setMeOrgFromResponse]
  );
  const getOrganization = useCallback(
    async (organizationId: string) => {
      const res = await doGetOrganization(organizationId);

      if (res && res.organization) {
        setMeOrgFromResponse(res.organization as Organization);
        res.organization.logo && upsert(res.organization.logo as Media);
      }

      return res;
    },
    [doGetOrganization, setMeOrgFromResponse]
  );

  return {
    updateMyOrganization: {
      updateOrganization,
      updateOrgLoading,
    },
    getMyOrganization: {
      getOrganization,
      getOrgLoading,
    },
  };
};
